import { Pipe, PipeTransform } from '@angular/core';
import {
  isLifeActMenuLevel,
  LifeActMenuLevel,
  LifeActMenuModule,
} from '@app/myWeeklyLifeActs/myLifeActsMenu/myLifeActsMenu.component';

@Pipe({ name: 'isMenuItemSelected' })
export class IsMenuItemSelectedPipe implements PipeTransform {
  public transform(
    menuItem: LifeActMenuLevel | LifeActMenuModule,
    currentlySelectedMenuItemFullUrl: string | undefined,
  ): boolean {
    const menuItemUlr: string = isLifeActMenuLevel(menuItem) ? menuItem.fullUrl : menuItem.fullUrlLifeActStep;
    return !!currentlySelectedMenuItemFullUrl && currentlySelectedMenuItemFullUrl.includes(menuItemUlr);
  }
}
